export default "//cdn.scentbird.com/assets/frontbird-site/images/fineFragrance_4ccc01.png";